import type { ReactNode } from "react";
import { Link } from "wouter";

/** The API supplies the verified canonical destination, including its market.
 * Unknown, removed and temporarily unverifiable profiles remain readable text. */
export function VerifiedCollectionLink({
  href, className, children,
}: { href?: string | null; className?: string; children: ReactNode }) {
  if (!href || !/^\/(?:[a-z]{2}\/)?collection\/[1-9]\d*$/.test(href)) {
    const plainClassName = className?.split(/\s+/).filter(token =>
      token !== "cursor-pointer" && !token.startsWith("group/") && !token.startsWith("hover:"),
    ).join(" ");
    return <span className={plainClassName}>{children}</span>;
  }
  const base = (import.meta.env.BASE_URL || "/").replace(/\/+$/, "");
  return <Link href={`~${base}${href}`} className={className}>{children}</Link>;
}
